import React from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelEmpty } from '../../../../component/common/designSystem';

/**
 * What these sections show instead of numbers when the cohort is too small.
 *
 * A deliberate state, not an error and not an empty one, so it says so plainly.
 * "No data" would be a lie — there is data, and it is being withheld because
 * reporting it would identify people. An admin who sees this and understands
 * why is far less likely to go looking for the same answer somewhere it is not
 * protected.
 *
 * THE PARTICIPANT COUNT IS NOT SHOWN, and the backend does not send it. That
 * matters more here than anywhere else in the panel: "7 people" in a department
 * of nine is most of the way to a name, and the fact being narrowed down is
 * that somebody is on prescription medication or in fertility treatment.
 */
const SuppressedPanel = ({ minimum, what = 'this programme', className = '' }) => (
  <div className={className}>
    <Panel title="Not enough people to report" subtitle="Withheld to protect participants">
      <PanelEmpty>
        Fewer than {minimum} people in the current view are using {what}. Figures stay hidden until
        there are at least {minimum}, so that nothing here can be traced back to an individual.
        Enrolling in one of these programmes is health information — in a small group, a single
        number is a personal record rather than a statistic.
        <br />
        <br />
        Widening the department filter, or switching between employees and members, may bring enough
        people into view.
      </PanelEmpty>
    </Panel>
  </div>
);

SuppressedPanel.propTypes = {
  minimum: PropTypes.number,
  what: PropTypes.string,
  className: PropTypes.string
};

export default SuppressedPanel;
